import { Component } from '@angular/core';

@Component({
    selector: 'app-ingestion-file-edit',
    template: '<app-ingestion-edit></app-ingestion-edit>',
    standalone: false
})
export class IngestionFileEditComponent {}
